<template>
    <input type="text" :value="displayValue" @blur="onBlur" @input="onInput" @click="onFocus" @mousedown.prevent
        :class="class_input" ref="inputEl" />
</template>
<script>
export default {
    name: "QtyInput",
    props: {
        value: { type: [Number, String], default: null },
        class_input: { type: [String, Array], default: "" },
        max: { type: [Number, String], default: 99999999.99 }
    },
    data() {
        return {
            internalValue: this.value,
            originalValue: this.value,
            isEditing: false,
        }
    },
    computed: {
        displayValue() {
            if (this.isEditing) {
                // Modo edición → mostrar sin formato
                return this.internalValue != null && !isNaN(this.internalValue) ? this.internalValue : "";
            }
            // Modo normal → formatear
            return this.formatDisplay(this.internalValue);
        }
    },
    mounted() {
        // Forzar formateo inicial siempre
        if (this.$refs.inputEl) {
            this.$refs.inputEl.value = this.displayValue;
        }
        // this.formatValue();
    },
    methods: {
        onInput(e) {
            let val = e.target.value.replace(/[^\d.]/g, "");
            if (parseFloat(val) > this.max) val = this.max.toString();
            this.internalValue = val;
            this.$emit('input', this.internalValue);
        },
        onBlur(event) {
            this.isEditing = false; // Salimos de edición
            let val = parseFloat(event.target.value.replace(/[^\d.]/g, ""));
            if (isNaN(val)) val = 0;
            if (val > this.max) val = this.max;
            val = parseFloat(val.toFixed(2));
            event.target.value = this.displayValue;
            if (this.internalValue !== this.originalValue) {
                // avisar que puede guardar, solo despues de un cambio
                this.originalValue = this.internalValue;
                this.$emit('save', this.internalValue);
            }
        },
        onFocus(e) {
            this.isEditing = true; // Activar modo edición
            setTimeout(() => {
                let rawValue = e.target.value;
                rawValue = rawValue.replace(/[$,]/g, "");
                e.target.value = rawValue;
                this.$nextTick(() => e.target.select());
            }, 0);
        },
        formatDisplay(rawValue) {
            let val = parseFloat((rawValue || "0").toString().replace(/[^\d.]/g, ""));
            if (isNaN(val)) val = 0;
            if (val > this.max) val = this.max;
            return `${val.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
        },
    }
};
</script>
